import { t } from "i18next";
import { ICON_BASE_PATH } from "../../../../utils/config";
import { TextBox, type TextBoxChangeEvent } from "@progress/kendo-react-inputs";

interface CompanyPoBoxProps {
  label: string;
  value: string;
  onChange: (e: string) => void;
  validationMessage?: string;
  showStarLabel?: boolean;
  max?: number;
  minLength?: number;
  disable?: boolean;
}

const CompanyPoBox: React.FC<CompanyPoBoxProps> = ({
  label,
  value,
  onChange,
  validationMessage,
  showStarLabel = true,
  max = 15,
  disable = false,
}) => {

  
  const sanitize = (s: string) =>
    s.replace(/[^a-zA-Z0-9]/g, "").slice(0, max);

  const handleChange = (e: TextBoxChangeEvent) => {
    const raw = String(e.value ?? "");
    onChange(sanitize(raw));
  };

  return (
    <div className="gx_input_container">
      <label
        className={`input-label gx-font-semibold ${value ? "floating" : ""}`}
      >
        {t(label)}
        {showStarLabel && (
          <span
            className={`gx_input_star ${
              value ? "gx_input_star_float" : "gx_input_star_normal"
            }`}
          >
            *
          </span>
        )}
      </label>

      <div
        className={`gx_input_cont ${
          !validationMessage || value ? "valid" : "invalid"
        }`}
      >
        <img src={`${ICON_BASE_PATH}name-input.svg`} alt="Name" />

        <TextBox
          value={value}
          onChange={handleChange}
          type="text"
          autoComplete="off"
          maxLength={max}
          disabled={disable}
          className="gx-textbox-css"
        />
      </div>

      {validationMessage && (
        <div className="gx_input_validationmessage">
          {validationMessage}
        </div>
      )}
    </div>
  );
};

export default CompanyPoBox;